const reportFiltersMap = {
  aggregate: 'reportsDateAggregate',
  sales_person_id: 'userId',
  status_id: 'reportsPipelineLeadStatus',
  sub_status_id: 'reportsPipelineLeadSubStatus',
  service_id: 'serviceId',
  stage_id: 'reportsPipelineStageId',
  milestone_stage_id: 'reportsMilestoneStageId',
  report_date_type: 'reportsDateType',
  service_provider_id: 'serviceProviderId',
  is_unique: 'reportsGoodLeads',
  pipeline_id: 'reportsPipelineId',
  reason_lost: 'reportsReasonLost',
  utm_medium: 'reportsUtmMedium',
  utm_source: 'reportsUtmSource',
  utm_campaign: 'reportsUtmCampaign',
  service_location_id: 'locationId',
  service_person_id: 'servicePersonId',
  event_type: 'reportsEventType',
  event_user_id: 'userId',
  leads: 'reportsGoodLeads',
  date_picker: 'datePicker',
  form_type: 'form_type',
};

export default reportFiltersMap;
